import { useEffect } from 'react';
import { showToast } from '../../../../common/domain/toast-provider';
import ItemsTabsNavigation, { ItemsTab } from './tabs-navigation';
import { useInteriorOrganizerStore } from '../../data/interior-organizer-store';
import UpsertStorageItem from './actions/upsert-storage-item';
import { getStorageItemsData } from '../../data/interior-organizer-data-service';
import StorageItemsList from './list/storage-items-list';
import StorageItemsFilters from './filters/filters';
import { formatStorageItems } from '../../domain/storage-items-provider';

const StorageItemsHome = () => {

    const storageItemsData = useInteriorOrganizerStore(store => store.storageItemsData);
    const setStorageItemsData = useInteriorOrganizerStore(store => store.setStorageItemsData);
    const itemsTab = useInteriorOrganizerStore(store => store.itemsTab);

    useEffect(() => {
        document.title = `Storage Items | Interior Organizer`;
    }, []);

    useEffect(() => {
        (async () => {
            const response = await getStorageItemsData();

            if(!response) {
                showToast('Get storage items error.');
                return;
            }

            setStorageItemsData(formatStorageItems(response));
        })();
    }, [setStorageItemsData]);

    return (
        <div className="grid md:grid-rows-[auto_auto] h-screen pb-10 content-start">
            <div>
                <h1 className="flex items-center text-xl xl:text-3xl mt-6 mb-4">
                    Storage Items
                </h1>

                <ItemsTabsNavigation/>

                {
                    itemsTab === ItemsTab.Default &&
                    <StorageItemsFilters />
                }
            </div>

            <div className="overflow-auto pr-4 pl-[2px]">
                {
                    itemsTab === ItemsTab.Default &&
                    storageItemsData?.items?.length > 0 &&
                    <StorageItemsList />
                }

                {
                    itemsTab === ItemsTab.AddNew &&
                    <UpsertStorageItem />
                }
            </div>

        </div>
    )
};

export default StorageItemsHome;